module.exports = __webpack_public_path__ + "img/sendai.c5c2d2b1.jpg";